var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { staticClass: "px-0", attrs: { fluid: "" } },
    [
      _vm.pregunta.dimension
        ? _c(
            "b-row",
            [
              _c("b-col", { staticClass: "text-center" }, [
                _c("span", { staticClass: "dimension" }, [
                  _c("strong", [
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.pregunta.dimension) },
                    }),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.pregunta.criterio
        ? _c(
            "b-row",
            [
              _c("b-col", { staticClass: "banner-criterio" }, [
                _c("span", {
                  domProps: { textContent: _vm._s(_vm.pregunta.criterio) },
                }),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.pregunta.criterio && _vm.pregunta.descripcionCriterio
        ? _c(
            "b-row",
            [
              _c("b-col", { staticClass: "descripcion-criterio" }, [
                _c("strong", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.cuestionarioSnp.pregunta.descripcionCriterio"
                        ) + ":"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.pregunta.descripcionCriterio),
                  },
                }),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("h5", [
              _c("strong", [
                _c("span", {
                  domProps: {
                    textContent: _vm._s(
                      `${_vm.$t(
                        "apeironGwApp.cuestionarioSnp.pregunta.pregunta"
                      )}  ${_vm.index} *`
                    ),
                  },
                }),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "m-2" },
            [
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "border" }, [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.pregunta.pregunta) },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                _vm._l(_vm.pregunta.opciones, function (opcion, oidx) {
                  return _c(
                    "b-col",
                    {
                      key: "opcion-" + _vm.pregunta.id + "-" + oidx,
                      staticClass: "border",
                      attrs: { cols: "12", lg: "6" },
                    },
                    [
                      _c(
                        "b-form-radio",
                        {
                          attrs: {
                            name: "pregunta_" + _vm.pregunta.id,
                            value: opcion,
                            disabled: _vm.esMoloLectura,
                          },
                          on: { change: _vm.emitirContestacion },
                          model: {
                            value: _vm.opcionRespuesta,
                            callback: function ($$v) {
                              _vm.opcionRespuesta = $$v
                            },
                            expression: "opcionRespuesta",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c("strong", [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(opcion.texto),
                                    },
                                  }),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "area-responsive area-responsive-texto pr-0 mr-3",
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(opcion.descripcion),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.pregunta.campoTexto
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "border" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.pregunta.campoTexto + ": *",
                                "label-for": `input-campo-texto-${_vm.pregunta.id}`,
                              },
                            },
                            [
                              _c("b-form-textarea", {
                                attrs: {
                                  name: `input-campo-texto-${_vm.pregunta.id}`,
                                  placeholder: _vm.pregunta.campoTexto,
                                  disabled: _vm.esMoloLectura,
                                },
                                on: { change: _vm.emitirContestacion },
                                model: {
                                  value: _vm.respuestaCampoTexto,
                                  callback: function ($$v) {
                                    _vm.respuestaCampoTexto = $$v
                                  },
                                  expression: "respuestaCampoTexto",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.comparaciones.length > 0
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "mt-4" }, [
                        _c("hr", { staticClass: "linea-horizontal-roja" }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "m-2" },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c(
                                  "h5",
                                  [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "apeironGwApp.cuestionarioSnp.pregunta.otrasEvaluaciones"
                                          )
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("b-icon", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.mostrarIndividualesVista,
                                          expression:
                                            "mostrarIndividualesVista",
                                        },
                                      ],
                                      attrs: {
                                        icon: "arrows-collapse",
                                        variant: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.mostrarIndividualesVista =
                                            !_vm.mostrarIndividualesVista
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("b-icon", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.mostrarIndividualesVista,
                                          expression:
                                            "!mostrarIndividualesVista",
                                        },
                                      ],
                                      attrs: {
                                        icon: "arrows-expand",
                                        variant: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.mostrarIndividualesVista =
                                            !_vm.mostrarIndividualesVista
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "area-responsive area-responsive-individuales px-4",
                                },
                                _vm._l(
                                  _vm.comparaciones,
                                  function (individual) {
                                    return _c(
                                      "b-row",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.mostrarIndividualesVista,
                                            expression:
                                              "mostrarIndividualesVista",
                                          },
                                        ],
                                        key: individual.cvu,
                                        staticClass: "border",
                                      },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "p-2",
                                            attrs: { cols: "12", lg: "2" },
                                          },
                                          [
                                            _c("strong", [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.cuestionarioSnp.pregunta.cvu"
                                                    ) + ":"
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  individual.cvu
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.cuestionarioSnp.pregunta.valoracion"
                                                    ) + ":"
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  individual?.contestacion
                                                    ?.respuestaNombre
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.cuestionarioSnp.pregunta.estado"
                                                    ) + ":"
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  individual?.estadoRevision
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("strong", [
                                              individual.recomendacion == true
                                                ? _c("span", {
                                                    staticClass: "text-success",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.cuestionarioSnp.recomendacion.seRecomienda"
                                                        )
                                                      ),
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              individual.recomendacion == false
                                                ? _c("span", {
                                                    staticClass: "text-danger",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.cuestionarioSnp.recomendacion.noSeRecomienda"
                                                        )
                                                      ),
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "p-2",
                                            attrs: { cols: "12", lg: "5" },
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "area-responsive area-responsive-texto pr-0 mr-3",
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            (individual
                                                              ?.contestacion
                                                              ?.campoTexto ??
                                                              "") + ":"
                                                          ),
                                                        },
                                                      }),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          individual
                                                            ?.contestacion
                                                            ?.respuestaCampoTexto
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "p-2",
                                            attrs: { cols: "12", lg: "5" },
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "area-responsive area-responsive-texto pr-0 mr-3",
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.$t(
                                                              "apeironGwApp.cuestionarioSnp.pregunta.comentariosGenerales"
                                                            ) + ":"
                                                          ),
                                                        },
                                                      }),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          individual?.comentariosGenerales
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("hr", { staticClass: "linea-horizontal-roja" }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }